export default class config {
    static get baseUrl() {
        return "";
    }


    // урл папки бэкенда на сайте клиники (слеш обязателен)
    static get dataUrl() {
        return "//medimadoc.ru/web/medangel-backend/"
    }

    // урл политики конфеденциальности на сайте клиники
    static get privateUrl() {
        return "http://medimadoc.ru/pacients/soglasie-na-obrabotku-hranenie-i-peredacu-personalnyh-dannyh"
    }


    static get partnerId() {
        return window.nebolitpro._partnerId;
    }

    /* For appointment widget only. */
    static get clinicId() {
        return 5;
    }

    static get scheduleLength() {
        return 7;
    }

    static get yandexMetrikaConfig() {
        return {
            id: 0,
        };
    }
}


/** WEBPACK FOOTER **
 ** ./src/config.js
 **/